import axios from 'axios'
import { FarmerSaleRecord } from '../../domain/entities/FarmerSale'
import {
  FarmerSaleRepository,
  GetFarmerSalesFilters,
  GetFarmerSalesResponse,
  HierarchyOption,
} from '../../domain/repositories/FarmerSaleRepository'
import { apiFarmerSaleDatasource } from '../datasources/FarmerSaleApiDatasource'

const extractErrorMessage = (err: unknown, fallback: string): string => {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { message?: string; error?: string } | undefined
    return data?.message || data?.error || fallback
  }

  return err instanceof Error ? err.message : fallback
}

export class FarmerSaleRepositoryImpl implements FarmerSaleRepository {
  public async getFarmerSales(filters: GetFarmerSalesFilters): Promise<GetFarmerSalesResponse> {
    try {
      return await apiFarmerSaleDatasource.getFarmerSales(filters)
    } catch (err) {
      throw new Error(extractErrorMessage(err, 'Failed to load farmer sales.'))
    }
  }

  public async getFarmerDetails(farmerId: string): Promise<FarmerSaleRecord[]> {
    try {
      return await apiFarmerSaleDatasource.getFarmerDetails(farmerId)
    } catch (err) {
      throw new Error(extractErrorMessage(err, 'Failed to load farmer sales details.'))
    }
  }

  public async getFpoOptions(): Promise<HierarchyOption[]> {
    try {
      return await apiFarmerSaleDatasource.getFpoOptions()
    } catch (err) {
      throw new Error(extractErrorMessage(err, 'Failed to load FPO options.'))
    }
  }

  public async getRetailerOptions(fpoId?: string): Promise<HierarchyOption[]> {
    try {
      return await apiFarmerSaleDatasource.getRetailerOptions(fpoId)
    } catch (err) {
      throw new Error(extractErrorMessage(err, 'Failed to load Retailer options.'))
    }
  }

  public async getVlccOptions(fpoId?: string): Promise<HierarchyOption[]> {
    try {
      return await apiFarmerSaleDatasource.getVlccOptions(fpoId)
    } catch (err) {
      throw new Error(extractErrorMessage(err, 'Failed to load VLCC options.'))
    }
  }
}

export const farmerSaleRepository = new FarmerSaleRepositoryImpl()
